import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { useMutation } from '@apollo/client';

import Loading from '../components/Loading';
import StyledPageContent from '../components/StyledPage';
import FormErrors, { trowError } from '../components/FormErrors';
import SubTitulo from '../components/Subtitulo';


// Assets
import ojo from '../assets/icons/ViewIcon.png';

import AcreditacionProfile, { LIST_ABONOS_PROFILE } from '../models/AcreditacionProfile';


const StyledPage = styled(StyledPageContent)`
  display: flex;
  align-items:center;
  justify-content:center;
  flex-wrap:wrap;
  height: 100%;
  max-width:800px;
  width:100%;
  margin:0 auto;
`


const Tabla=styled.div`
 th{
  background:var(--color-rojo);
  color:#ffffff;
  text-align:center;
  padding:10px 15px;
 }
 td{
  color:var(--color-azul);
  text-align:center;
  padding:10px 15px;
 }
`;







export default  () => {
    let UserInfo=AcreditacionProfile.getProfile();
  
    const [ getListAbonosProfile,{ data } ] = useMutation(LIST_ABONOS_PROFILE);
    const [submitError,setSubmitError] = useState<null|string>(null);
    const [loading,setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try{
                setLoading(true);

                await getListAbonosProfile({
                    variables:{
                        profile_uuid:UserInfo.uuid
                    }
                });
            
            }catch(e){
                console.error(e);
                setSubmitError(e);
                window.scrollTo(0,0);
            }finally{
                setLoading(false);
            }
        })();
    },[]);


    if(loading)
        return <Loading />


    console.log('Data:',data)

    return (
        <StyledPage>
            <SubTitulo>
                <h2>MIS ASIENTOS</h2>
            </SubTitulo>
            {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
            <Tabla>
                <table>
                    <tr>
                        <th>Tipo</th>
                        <th>Zona</th>
                        <th>Seccion</th>
                        <th>Fila</th>
                        <th>Asiento</th>
                        <th>Ver Zona</th>
                    </tr>
                    {data?.listAbonos?.edge?.map( item => (
                        <tr>
                            <td>{item.tipo}</td>
                            <td>{item.zona}</td>
                            <td>{item.seccion}</td>
                            <td>{item.fila}</td>
                            <td>{item.asiento}</td>
                            <td><a href={`https://www.atleticodesanluis.mx/estadio360/?location=${item.vista}`} target="_blank"><img src={ojo}  width="50"/></a></td>
                        </tr>
                    ))}
                </table>
            </Tabla>
          
        </StyledPage>
    )
}